import { Link } from 'react-router-dom';
import { CheckCircle, Music, User } from 'lucide-react';
import { cn } from '../../lib/cn.js';

interface ArtistCardProps {
  slug: string;
  name: string;
  avatarUrl?: string | null;
  isVerified?: boolean;
  songCount?: number;
  className?: string;
}

export function ArtistCard({
  slug,
  name,
  avatarUrl,
  isVerified,
  songCount,
  className,
}: ArtistCardProps) {
  return (
    <Link
      to={`/artists/${slug}`}
      className={cn(
        'flex flex-col items-center gap-3 p-4 rounded-xl hover:bg-surface-hover transition-colors group',
        className,
      )}
    >
      <div className="w-20 h-20 rounded-full overflow-hidden bg-surface-hover ring-2 ring-transparent group-hover:ring-primary transition-all">
        {avatarUrl ? (
          <img src={avatarUrl} alt={name} className="w-full h-full object-cover" />
        ) : (
          <div className="w-full h-full flex items-center justify-center">
            <User size={32} className="text-text-muted" />
          </div>
        )}
      </div>
      <div className="text-center">
        <p className="text-sm font-medium text-text-primary group-hover:text-primary transition-colors flex items-center gap-1 justify-center">
          {name}
          {isVerified && <CheckCircle size={14} className="text-primary" />}
        </p>
        {songCount !== undefined && (
          <p className="text-xs text-text-muted mt-0.5 flex items-center gap-1 justify-center">
            <Music size={10} />
            {songCount} canciones
          </p>
        )}
      </div>
    </Link>
  );
}
